import Pagination from '@/vuex/modules/pagination'
import Usuario from '@/vuex/modules/usuario'
import Perfil from '@/vuex/modules/perfil'
import Area from '@/vuex/modules/area'
import Participante from '@/vuex/modules/participante'
import Estado from '@/vuex/modules/estado'
import Cidade from '@/vuex/modules/cidade'
import Modulo from '@/vuex/modules/modulo'
import Permissao from '@/vuex/modules/permissao'
import Formulario from '@/vuex/modules/formularios'
import TokenEmail from '@/vuex/modules/token'
import ArtigoSugestao from '@/vuex/modules/artigoSugestao'
import ArtigoComentario from '@/vuex/modules/artigoComentario'
import Participacao from '@/vuex/modules/participacao'
import Conferencia from '@/vuex/modules/conferencia'

export default {
  modules: {
    usuario: Usuario,
    estado: Estado,
    cidade: Cidade,
    participante: Participante,
    token: TokenEmail,
    pagination: Pagination,
    modulo: Modulo,
    permissao: Permissao,
    formulario: Formulario,
    perfil: Perfil,
    area: Area,
    artigoSugestao: ArtigoSugestao,
    artigoComentario: ArtigoComentario,
    participacao: Participacao,
    conferencia: Conferencia
  }
}



// WEBPACK FOOTER //
// ./src/vuex/store.js